import type { AccountStateReason, InvitationRevokeResolutionDto, UserDto } from '@/types/generated/schemas';

type BlockedActionReason = NonNullable<UserDto['blocked_actions']>[string];
export type RevokeRefusalReason =
  | BlockedActionReason
  | Extract<AccountStateReason, 'ACCOUNT_OPERATION_IN_PROGRESS' | 'MAINTENANCE_FREEZE'>;

export const blockedActionMessages: Record<BlockedActionReason, string> = {
  SETUP_IN_PROGRESS: 'Account setup is in progress. Try again once it finishes.',
  NEEDS_REPAIR: 'This invitation needs support to repair it.',
  REVOKE_UNFINISHED: 'The previous revoke did not finish. Retry revoke.',
  REVOKE_IN_PROGRESS: 'Another revoke for this email is running.',
  READ_ONLY: 'This organization is in read-only mode.',
  NOT_AUTHORIZED: 'This action is not available to you.',
  NOT_SUPPORTED: 'This action is not available for this invitation.',
  ALREADY_ACCEPTED: 'This invitation has already been accepted.',
  RESOLUTION_CONFLICT: 'A different resolution was recorded. The roster will show that decision.',
  TENANT_NOT_READY: 'This account action is unavailable until account safety checks are ready. Please contact support.',
};

export const revokeRefusalMessages: Record<RevokeRefusalReason, string> = {
  ...blockedActionMessages,
  ACCOUNT_OPERATION_IN_PROGRESS: 'Another account operation is running. Please try again shortly.',
  MAINTENANCE_FREEZE: 'This action is temporarily paused for maintenance. Please try again later.',
};

export const blockedResolutionMessages: Record<NonNullable<InvitationRevokeResolutionDto['blocked_reason']>, string> = {
  ORGANIZATION_INACTIVE: 'The organization is inactive. Support must review this resolution.',
  SANITIZE_FAILED: 'Sanitization failed. Support must review this resolution.',
  TENANT_NOT_READY: 'The account service is not ready. Support must review this resolution.',
  ACCOUNT_CHANGED: 'The account changed during resolution. Support must review this resolution.',
};

export const getRevokeRefusalReason = (reason?: string): RevokeRefusalReason | undefined =>
  reason && Object.prototype.hasOwnProperty.call(revokeRefusalMessages, reason)
    ? (reason as RevokeRefusalReason)
    : undefined;
